import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import {
  selectSite,
  selectPages,
  updateSite,
  saveSite,
  savePage,
  selectPage,
  updateCurrentPage,
  selectCurrentPage,
} from 'shared/state/ducks/sites';
import { UserSyncChangesDialog } from './UserSyncChangesDialog';
import { setResetToFalse } from 'shared/state/ducks/ui';
import {
  swapResetData,
  resetChange,
  saveSitePages,
  refreshSiteBaseline,
} from 'shared/state/ducks/site';

interface UserSyncChangesDialogContainerProps {
  site?: Site;
  siteId: number;
  pageId: number;
  showToastMessage: boolean;
}

const mapStateToProps = (
  state: RootState,
  ownProps: UserSyncChangesDialogContainerProps
) => ({
  site: selectSite(ownProps.siteId)(state),
  pages: selectPages(ownProps.siteId)(state),
  hasChanged: state.site.hasChanged,
  userModifiedDataState: state.site.newData,
  page: selectPage(ownProps.siteId, ownProps.pageId)(state),
  currentPage: selectCurrentPage(ownProps.siteId, ownProps.pageId)(state),
  showToastMessage: ownProps.showToastMessage,
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  ownProps: UserSyncChangesDialogContainerProps
) => ({
  updateSite: (site: Site) => {
    dispatch(updateSite(ownProps.siteId, site));
  },
  saveSite: (showToastMessage?: boolean) => {
    return dispatch(saveSite(ownProps.siteId, showToastMessage));
  },
  setResetToFalse: () => dispatch(setResetToFalse()),
  saveSitePages: (site: Site, pages: Array<Page>) => {
    dispatch(saveSitePages(site, pages));
  },
  updateCurrentPage: (pageVersion: PageVersion) => {
    dispatch(updateCurrentPage(ownProps.siteId, pageVersion));
  },
  swapResetData: () => {
    dispatch(swapResetData());
  },
  resetUserSyncChange: () => {
    dispatch(resetChange());
  },
  savePage: (pageId: number, page: PageVersion, skipSiteRefresh?: boolean) => {
    return dispatch(savePage(ownProps.siteId, pageId, page, skipSiteRefresh));
  },
  refreshSiteBaseline: () => {
    dispatch(refreshSiteBaseline(ownProps.siteId));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserSyncChangesDialog);
